export enum MovieDimension {
  TwoD = 0,
  ThreeD = 1,
  FourXD = 2,
  DolbyAtmos = 3,
}

export const MovieDimensionTranslations = {
  [MovieDimension.TwoD]: 'movies.two_d',
  [MovieDimension.ThreeD]: 'movies.three_d',
  [MovieDimension.FourXD]: 'movies.four_x_d',
  [MovieDimension.DolbyAtmos]: 'movies.dolby_atmos',
};

export const MovieDimensionOptions = [
  { value: MovieDimension.TwoD, key: 'movies.two_d' },
  { value: MovieDimension.ThreeD, key: 'movies.three_d' },
  { value: MovieDimension.FourXD, key: 'movies.four_x_d' },
  { value: MovieDimension.DolbyAtmos, key: 'movies.dolby_atmos' },
];
